const audioCache: Record<string, HTMLAudioElement> = {};

/**
 * Return true if the browser is Internet Explorer, false otherwise.
 */
function isIE(): boolean {
  const ua = navigator.userAgent;

  // IE 5 - 10
  // eslint-disable-next-line no-plusplus
  for (let version = 5; version < 11; version++) {
    if (ua.indexOf(`MSIE ${version}`) > 0) {
      return true;
    }
  }

  // IE 11+
  return ua.indexOf('Trident/') > 0;
}

/**
 * Load a sound into the audio cache.
 *
 * Call .play() on the returned object to play the sound.
 *
 * @param wavUrl The URL to a wav sound file
 * @param mp3Url The URL to an mp3 sound file
 */
export const loadAudio = (wavUrl: string, mp3Url: string): HTMLAudioElement => {
  const fullUrl = isIE() ? mp3Url : wavUrl;

  if (typeof audioCache[fullUrl] === 'undefined') {
    audioCache[fullUrl] = new Audio(fullUrl);
  }
  return audioCache[fullUrl];
};
